import { useEffect } from 'react';

export const isLocalProd =
  import.meta.env.VITE_LOCAL_PROD === '1' ||
  import.meta.env.VITE_LOCAL_PROD === 'true';
export const BANNER_HEIGHT = 56;

export const LocalProdBanner = () => {
  useEffect(() => {
    if (!isLocalProd) {
      return;
    }

    const body = document.body;
    const previousBackgroundImage = body.style.backgroundImage;
    const previousBackgroundColor = body.style.backgroundColor;
    const previousBackgroundSize = body.style.backgroundSize;
    const previousBackgroundAttachment = body.style.backgroundAttachment;

    body.style.backgroundImage =
      'repeating-linear-gradient(-45deg, #fff200, #fff200 28px, #ff4d4d 28px, #ff4d4d 56px)';
    body.style.backgroundColor = '#fff200';
    body.style.backgroundSize = '32px 32px';
    body.style.backgroundAttachment = 'fixed';

    return () => {
      body.style.backgroundImage = previousBackgroundImage;
      body.style.backgroundColor = previousBackgroundColor;
      body.style.backgroundSize = previousBackgroundSize;
      body.style.backgroundAttachment = previousBackgroundAttachment;
    };
  }, [isLocalProd]);

  if (!isLocalProd) {
    return null;
  }

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: `${BANNER_HEIGHT}px`,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 150,
          pointerEvents: 'none',
          background:
            'repeating-linear-gradient(-45deg, rgba(255, 250, 0, 0.16), rgba(255, 250, 0, 0.16) 28px, rgba(255, 77, 77, 0.16) 28px, rgba(255, 77, 77, 0.16) 56px)',
          mixBlendMode: 'multiply',
        }}
      />
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10000,
          background:
            'linear-gradient(90deg, #ff3b30 0%, #ff6b00 50%, #ff3b30 100%)',
          color: '#ffffff',
          textAlign: 'center',
          fontWeight: 900,
          letterSpacing: '0.12em',
          padding: '14px 16px',
          textTransform: 'uppercase',
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.35)',
          pointerEvents: 'none',
        }}
      >
        ⚠ LOCAL PRODUCTION MODE – HANDLE WITH CARE ⚠
      </div>
    </>
  );
};
